<template>
    <div class="flex items-center gap-4">
        <div class="sim-article-card__author">
            <CoreImg v-if="author?.imageUrl"
                     :src="author?.imageUrl"
                     class="sim-article-card__author-img"
                     preset="default"
                     height="40"
                     width="40"
                     alt=""
                     loading="lazy"
            />

            {{ author?.getFullName() }}
        </div>

        <span v-if="time" class="sim-article-card__time sim-eyebrow">
            <IconStopwatch size="sm" />

            {{ $t('units.minutes', (time ?? 0)) }}
        </span>
    </div>
</template>

<script lang="ts" setup>

const {
    author,
    time,
} = defineProps<{
    author: InstanceType<typeof ArticleAuthorModel> | null
    time?: number | null
}>()

</script>

<style lang="scss" scoped>
.sim-article-card__author {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    @include sim-font-bold;
}

.sim-article-card__author-img {
    object-fit: cover;

    border-radius: 100%;
}

.sim-article-card__time {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    color: $sim-c-simplo-darker;

    &::before {
        content: '';
        font-size: 2rem;
        height: 2rem;

        margin: 0 1rem;

        rotate: 45deg;

        border: 1px solid $sim-c-basic-600;
    }
}
</style>
